module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/wristband.5716dd43.png";